
import MHStreamPresenterEffect from './MHStreamPresenterEffect';

/**
 * Creates a new instance of MHStreamPresenterEffect.
 *
 * @param {MediaStream} stream - The video stream which will be used for
 * creating the presenter effect.
 * @returns {Promise<MHStreamPresenterEffect>}
 */
export function createPresenterEffect(stream: MediaStream) {
    if (!MediaStreamTrack.prototype.getSettings
        && !MediaStreamTrack.prototype.getConstraints) {
        return Promise.reject(new Error('MHStreamPresenterEffect not supported!'));
    }

    return Promise.resolve(new MHStreamPresenterEffect(stream));
}
